import { Component, Input, output } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';
import type { Invitation } from '@recruitee/invitations-types';
import {
  ButtonComponent,
  DateComponent,
  GroupComponent,
  HeadingComponent,
  IconComponent,
  TruncateComponent,
} from '@recruitee/user-interface';

@Component({
  selector: 'rt-invitation-item',
  templateUrl: './invitation-item.component.html',
  styleUrls: ['./invitation-item.component.less'],
  imports: [
    ButtonComponent,
    DateComponent,
    GroupComponent,
    HeadingComponent,
    IconComponent,
    TruncateComponent,
    TranslatePipe,
  ],
})
export class InvitationItemComponent {
  @Input() public invitation: Invitation;
  @Input() public readOnly: boolean;

  public resendInvitation = output<Invitation>();
  public deleteClick = output<Invitation>();
}
